import { EventEmitter, Injectable } from '@angular/core';
import { ZONE } from '../zone/zone.service';

@Injectable({
  providedIn: 'root'
})
export class ConstituencyService {

  is_display_constituency_register_component = false;
  constituencyUpdate = new EventEmitter<ZONE>();
  downloadConstituency = new EventEmitter<boolean>();
  private _constituency: CONSTITUENCY = null;

  constructor() {
  }

  set set_constituency_data(constituency) {
    this._constituency = constituency;
  }

  get get_constituency_data() {
    return this._constituency;
  }
}

export interface CONSTITUENCY {
  id: number;
  name: string;
}
